export const ExternalURLs = {
  FAQ: 'https://www.instacoins.com/frequently-asked-questions/',
  REFUND_POLICY: 'https://www.instacoins.com/refund-policy/',
  TERMS: 'https://www.instacoins.com/terms-conditions/',
  SAFE_CONNECT_PIS: 'https://yapi.ly/MwMo',
};
